<template>
  <div class="cbg-white-container input-container theme--light v-card p-16 border-card">
    <div class="col-sm-12 pl-0 pr-0">
      <h3>
        <b>Welcome</b>
      </h3>
      <h5>
        This board shows the total no. of points in the system due to user
        referrals.
      </h5>
    </div>
    <div class="col-sm-12 p-0 m-0">
      <div class="row">
        <div class="col-sm-6 col-md-3">
          <div class="border p-3 rounded">
            <h2 class="mb-1">{{ dashboard.added }}</h2>
            <h5 class="mb-0">TOTAL POINTS</h5>
          </div>
        </div>

        <div class="col-sm-6 col-md-3">
          <div class="border p-3 rounded">
            <h2 class="mb-1">{{ dashboard.total }}</h2>
            <h5 class="mb-0">TOTAL REFERRALS</h5>
          </div>
        </div>
        <div class="col-sm-6 col-md-3">
          <div class="border p-3 rounded">
            <h2 class="mb-1">{{ dashboard.used }}</h2>
            <h5 class="mb-0">POINTS USED</h5>
          </div>
        </div>
        <div class="col-sm-6 col-md-3">
          <div class="border p-3 rounded">
            <h2 class="mb-1">{{ dashboard.balance }}</h2>
            <h5 class="mb-0">BALANCE</h5>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-12 row">
      <hr class="w-100" />
    </div>
    <div class="col-sm-12">
      <h3>
        <b>Settings</b>
      </h3>
      <div v-if="permissions.includes('CAN_DEACTIVE_REFERRAL_DASHBOARD')">
        <p class="mt-4">
          You can deactivate/activate the referral system anytime and also
          change the point system.
        </p>
        <div class="toggle-switch">
          <v-switch hide-details color="success" label="Activate" v-model="is_active_global"></v-switch>
        </div>
      </div>
    </div>
    <div class="col-sm-12 p-0 row m-0">
      <v-form class="col-sm-12 p-0 row m-0" ref="createForm" v-model="valid" lazy-validation>
        <div class="col-sm-3">
          <label for>Points for referrer</label>
          <v-text-field
            placeholder="100"
            v-model="points_for_referrer"
            type="number"
            :rules="pointsRules"
            persistent-hint
            outlined
          ></v-text-field>
        </div>
        <div class="col-sm-3">
          <label for>Points for referred</label>
          <v-text-field
            placeholder="100"
            v-model="points_for_referred"
            type="number"
            :rules="pointsRules"
            persistent-hint
            outlined
          ></v-text-field>
        </div>
        <div class="col-sm-3">
          <label for>Expiry (in days)</label>
          <v-text-field
            placeholder="30"
            v-model="expiry"
            type="number"
            :rules="expirationRules"
            persistent-hint
            outlined
          ></v-text-field>
        </div>
        <div
          v-if="permissions.includes('CAN_SAVE_REFERRAL_DASHBOARD')"
          class="col-sm-6 dashboard-refer"
        >
          <v-btn
            color="success"
            outlined
            @click="saveSettings()"
            :loading="isLoading"
            :disabled="!valid"
          >Save</v-btn>
        </div>
      </v-form>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import config from "@/config.js";
import Swal from "sweetalert2";
const ACCOUNTS_API_URL = `${config.ACCOUNTS_URL}ds-accounts-be`;

export default {
  data() {
    return {
      setting_type: "referral_settings_global",
      points_for_referrer: 0,
      points_for_referred: 0,
      expiry: 0,
      is_active_global: false,
      dashboard: {
        used: 0,
        balance: 0,
        added: 0,
        total: 0
      },
      pointsRules: [
        v => !!v || "Item is required",
        v => +v >= 0 || "Value must positive",
        v => Number.isInteger(+v) || "Value must be an integer"
      ],
      expirationRules: [
        v => !!v || "Item is required",
        v => +v > 0 || "Value must be greater than 0",
        v => Number.isInteger(+v) || "Value must be an integer"
      ],
      valid: false,
      isLoading: false
    };
  },
  computed: {
    ...mapGetters({
      permissions: "getPermissions"
    })
  },
  mounted() {
    this.getSettings();
    this.getDashboard();
  },
  methods: {
    saveSettings() {
      this.isLoading = true;
      let obj = {
        setting_type: this.setting_type,
        points_for_referrer: this.points_for_referrer,
        points_for_referred: this.points_for_referred,
        is_active_global: this.is_active_global,
        expiry: this.expiry
      };
      let url = `${config.BASE_URL}api/v2/admin/referral-settings`;
      this.$http.put(url, obj).then(response => {
        if (response.body.status) {
          this.isLoading = false;
          Swal.fire(`Save Successfully`);
        } else {
          this.isLoading = false;
          Swal.fire(response.body.message);
        }
      });
    },
    getSettings() {
      let url = `${config.BASE_URL}api/v2/admin/referral-settings`;
      this.$http.get(url).then(response => {
        if (response.body.status && response.body.data !== null) {
          this.is_active_global = response.body.data.is_active_global;
          this.points_for_referrer = response.body.data.points_for_referrer;
          this.points_for_referred = response.body.data.points_for_referred;
          this.expiry = response.body.data.expiry;
          this.dashboard.total = response.body.data.total_referrals;
        }
      });
    },
    getDashboard() {
      let url = `${ACCOUNTS_API_URL}/userCredit/dashboard`;
      this.$http.get(url).then(response => {
        if (response.body.status) {
          this.dashboard = response.body.data[0];
        }
      });
    }
  }
};
</script>